<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      >
      </Table>
    </template>
  </Content>
</template>

<script>
import Table from "@/components/Table";
import Content from "@/layout/Content";

import { getSiteSections as fetchData } from "@/api/siteSection";

const columnsOptions = {
  sortable: false,
  itemsName: "items",
  controls: true,
  editable: true,
  id: "id",
  search_list: [
    {
      label: "Поиск по ID",
      name: "site_section_id",
      strong: true,
    },
    {
      label: "Поиск по названию",
      name: "name",
    },
  ],
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "name",
    label: "Название",
  },
  {
    prop: "hidden",
    label: "Скрыто",
    type: "bool",
  },
  {
    prop: "priority",
    label: "Приоритет",
    width: 150,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
      },
    };
  },
};
</script>
